export const tr = {
    emptyMessage: 'Değer girin',
    integerMessage: 'Değer bir tam sayı olmalıdır',
    nanMessage: 'Değer bir sayı olmalıdır',
    tooBig: 'Değer çok yüksek. İzin verilen değerler: {minLimit} - {maxLimit}',
    tooLittle: 'Değer çok düşük. İzin verilen değerler: {minLimit} - {maxLimit}\r'
};
